<template>
  <div class="shrink-0" v-if="user">
    <div
      :class="size"
      class="bg-primary/5 text-primary rounded-full flex items-center justify-center"
    >
      <BaseImage
        @contextmenu.prevent
        @dragstart.prevent
        :uri="user.avatar"
        v-if="user.avatar"
        :img-class="[
          'rounded-full  object-cover border border-slate-100',
          size,
        ]"
      />

      <div
        v-else
        class="bg-primary-blue rounded-full text-white uppercase font-bold flex items-center justify-center"
        :class="[size, text]"
      >
        {{ getInitials(user.name, user.last_name) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AppUser } from "~~/types/user";

withDefaults(
  defineProps<{
    user: AppUser | null;
    size?: string;
    text?: string;
  }>(),
  {
    size: "sm:w-32 sm:h-32 h-28 w-28",
    text: "text-3xl",
  },
);
</script>
